/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";

import { Stack, StackItem, Text } from "@fluentui/react";

import { getFormattedDateTime } from "Utility/FormatHelper";

import {
  commentContainerStackStyles,
  commentStackTokens,
  commentTextStackStyles,
  commentTextStyles,
  createdDateTextStyles,
  createdTextStyles,
} from "./CommentDetail.styles";
import { ICommentDetailProps } from "./ICommentDetailProps";

const CommentDetail = (props: ICommentDetailProps): React.ReactElement => {
  const { userProfileComment } = props;

  return (
    <Stack key={userProfileComment.id} horizontal styles={commentContainerStackStyles}>
      <Stack>
        <StackItem>
          <Text styles={createdTextStyles}>Created on:</Text>
        </StackItem>
        <StackItem>
          <Text styles={createdDateTextStyles}>
            {getFormattedDateTime(userProfileComment.dateCreated)}
          </Text>
        </StackItem>
      </Stack>
      <Stack styles={commentTextStackStyles} tokens={commentStackTokens}>
        <StackItem>
          <Text styles={commentTextStyles}>{userProfileComment.text}</Text>
        </StackItem>
        <StackItem>
          <Text styles={createdTextStyles}>Created by: {userProfileComment.createdBy}</Text>
        </StackItem>
      </Stack>
    </Stack>
  );
};

export default CommentDetail;
